<template>
  <div class="home">
    <div id="heading">
      <div class="header-icon fa fa-home"></div>
      <h1>Home Insurance</h1>
    </div>
    <section id="main" class="wrapper">
      <div class="inner">
        <div class="content">
          <div class="text-center">
            <h2>Protect Your Home and Everything In It</h2>
          </div>

          <p>At SIG & Associates, we know how hard you’ve worked to turn your house into a home.
            Since your home is one of the most important financial investments of your lifetime,
            you’ll need proper coverage in order to keep your investment protected and provide
            your family with the guarantee that they’ll always be safe and sound.</p>

          <p>SIG & Associates is your trusted solution for homeowners insurance.
            We offer coverage options that are both flexible and affordable, and will work with you on an
            individual basis to find a policy that best suits your needs. Our team is dedicated to
            providing the assurance that your family and your possessions are secure.</p>

          <p>Our Home Insurance coverage options include:</p>

          <ul>
            <li class="list-item link" @click="handleModal()" data-page="property">
              Property Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="high-value">
              High Value Homeowners Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="home-owner">
              Homeowners Liability
            </li>
            <li class="list-item link" @click="handleModal()" data-page="renters">
              Renters Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="condo">
              Condo Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="mobile">
              Mobile Home Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="s-property">
              Scheduled Property Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="landlord">
              Landlords Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="flood">
              Flood Insurance
            </li>
            <li class="list-item link" @click="handleModal()" data-page="home-biz">
              In-Home Business Insurance
            </li>
          </ul>

          <div class="text-center">
            <h2>Why Home Insurance?</h2>
          </div>
          <p>Accidents can happen at any time. Having the right insurance can protect your home and everything in it,
            as well as keep your property covered from damages and accidents.</p>
          <p>While standard Home Insurance can cover anything from fire and weather damage to injuries and theft,
            not all damages and accidents may be insured under a standard policy.
            That’s why it’s important to talk to an insurance specialist at
            SIG & Associates about specific coverage options that are applicable to your individual needs.</p>
          <p>Don’t go another day without proper homeowners insurance. Keep your memories protected with the right
            policy from SIG & Associates.</p>
          <p>SIG & Associates provides Home Insurance for residents near Wichita Falls, Haslet, Decatur, Prosper,
            Vernon, and Garland.</p>
        </div>
        <hr>
        <div class="content">
          <GetQuoteForm class="get-quote"/>
        </div>
        <hr>
      </div>
    </section>
    <modal v-if="showModal" @close="showModal = false" v-bind:header="modalHeader" v-bind:body="modalBody"/>
  </div>
</template>

<script>
import Vue from 'vue'

import Modal from '@/widgets/Modal'
import GetQuoteForm from '@/components/GetQuoteForm'

import homeHelper from '../helpers/homeHelper.js'

Object.defineProperty(Vue.prototype, '$homeHelper', {value: homeHelper})
Vue.component('modal')

export default {
  name: 'Home Insurance',
  methods: {
    handleModal: function () {
      let action = event.target.attributes['data-page'].value

      this.modalHeader = this.templates[action].header
      this.modalBody = this.templates[action].body

      this.showModal = true
    }
  },
  data: function () {
    return {
      showModal: false,
      modalHeader: '',
      modalBody: '',
      templates: this.$homeHelper
    }
  },
  components: {
    Modal,
    GetQuoteForm
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

.list-item.link {
  cursor: pointer;
  padding: 10px;
}

.list-item.link:hover {
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/components/Home.vue